import React from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import CostDataTable from './CostDataTable'

const Cost = () => {
    return (
        <div>
            <Header/>
            <Menu/>
            <div className="content-wrapper">
                <CostDataTable/>
            </div>
            <Footer/>
        </div>
    )
}

export default Cost